import QueryService from '@/services/QueryService'

const getCurrentDateAndTime = () => {
  var today = new Date()
  var dd = String(today.getDate()).padStart(2, '0')
  var mm = String(today.getMonth() + 1).padStart(2, '0')
  var yyyy = today.getFullYear()
  return mm + '/' + dd + '/' + yyyy
}

const getUsage = async () => {
  const response = await QueryService.query({
    queryType: 'Usage'
  })
  var names = []
  var counts = []
  response.data.forEach(function (item, index) {
    names.push(item['name'])
  })
  var uniqueNames = [...new Set(names)]
  uniqueNames.forEach(function (item, index) {
    counts.push(names.filter(x => x === item).length)
  })
  names = [...new Set(names)]
  return {names: names, counts: counts}
}

export default {
  getUsage,
  getCurrentDateAndTime
}



// WEBPACK FOOTER //
// ./src/utils.js